import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaSpinner } from "react-icons/fa";
import { useAuthStore } from "../store/authStore";

const PurchaseSuccessPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuthStore();

  useEffect(() => {
    if (user?.paid_credits) {
      navigate("/home");
    }
  }, [t, user?.paid_credits, navigate]);

  return (
    <div className="max-w-2xl mx-auto p-8 rounded-lg shadow-xl text-white text-center flex flex-col items-center justify-center min-h-screen">
      <h1 className="text-2xl font-bold mb-6">
        {t("purchaseSuccessPage.title", "Purchase Status")}
      </h1>
      <FaSpinner className="animate-spin text-4xl mb-4" />
      <p className="text-lg">
        {t(
          "purchaseSuccessPage.processing",
          "Processing your payment, please wait..."
        )}
      </p>
    </div>
  );
};

export default PurchaseSuccessPage;
